import { Link } from "react-router-dom";
import { Rocket, Compass, Sparkles, Trophy } from "lucide-react";
import { ConnectMenu } from "../WalletButton";
import { useAccount } from "wagmi";

const Cta = ({ to, icon: Icon, label, primary, testid }) => (
  <Link to={to} data-testid={testid} className={primary ? "btn-lime px-5 py-2.5 text-sm" : "inline-flex items-center gap-2 rounded-lg border border-white/15 bg-black/40 px-5 py-2.5 text-sm font-semibold text-slate-200 transition-colors hover:border-lime/50 hover:text-lime"}>
    <Icon className="h-4 w-4" /> {label}
  </Link>
);

export const HomeHero = () => {
  const { isConnected } = useAccount();
  return (
    <section data-testid="home-hero" className="relative overflow-hidden rounded-2xl border border-white/10 bg-[#07090c]/90 px-5 py-10 sm:px-10 sm:py-14 fade-up">
      <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-lime/10 blur-3xl" />
      <p className="text-[11px] font-bold uppercase tracking-[0.3em] text-lime">Robinhood Chain launchpad</p>
      <h1 className="mt-3 max-w-4xl font-display text-4xl font-black leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-6xl">
        Discover tokens. <span className="text-lime drop-shadow-[0_0_18px_rgba(57,255,20,0.35)]">Launch projects.</span> Compete. Build communities.
      </h1>
      <p className="mt-4 max-w-2xl text-sm text-slate-400 sm:text-base">Find the next Robinhood Chain project, launch your own in minutes and trade it right on its token page.</p>
      <div className="mt-7 flex flex-wrap gap-3">
        <Cta to="/launch" icon={Rocket} label="Launch token" primary testid="hero-launch" />
        <Cta to="/explore" icon={Compass} label="Explore tokens" testid="hero-explore" />
        <a href="#featured" data-testid="hero-featured" className="inline-flex items-center gap-2 rounded-lg border border-white/15 bg-black/40 px-5 py-2.5 text-sm font-semibold text-slate-200 hover:border-lime/50 hover:text-lime"><Sparkles className="h-4 w-4" /> Featured</a>
        <a href="#competitions" data-testid="hero-competitions" className="inline-flex items-center gap-2 rounded-lg border border-white/15 bg-black/40 px-5 py-2.5 text-sm font-semibold text-slate-200 hover:border-lime/50 hover:text-lime"><Trophy className="h-4 w-4" /> Competitions</a>
        {!isConnected && <ConnectMenu testid="hero-connect-wallet" />}
      </div>
    </section>
  );
};

export const SectionHead = ({ title, right, id, testid }) => (
  <div id={id} className="mb-5 flex scroll-mt-24 flex-col gap-2 border-b border-white/10 pb-3 sm:flex-row sm:items-end sm:justify-between" data-testid={testid}>
    <h2 className="flex items-center gap-3 font-display text-xl font-black tracking-tight text-white sm:text-2xl"><span className="inline-block h-6 w-2.5 rounded-sm bg-lime shadow-[0_0_10px_#39FF14]" />{title}</h2>
    {right}
  </div>
);
